module.exports = __webpack_public_path__ + "img/ca-logo-2021-640x256.a97f4368.png";